<template>
    <div class="user">
        <div class="common-seach-wrap">
            <el-form size="small" :inline="true" :model="query" class="demo-form-inline">
                <el-form-item label="标题">
                    <el-input v-model="query.keyword" placeholder="请输入标题" clearable></el-input>
                </el-form-item>
                <el-form-item label="创建时间">
                    <div class="block">
                        <span class="demonstration"></span>
                        <el-date-picker size="small" v-model="query.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--添加等级-->
        <div class="common-level-rail">
            <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus" v-auth="'/education/exam/add'">添加考试</el-button>
        </div>
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="exam_id" label="考试ID" width="80"></el-table-column>
                    <el-table-column prop="title" label="标题"></el-table-column>
                    <el-table-column prop="course" label="课程" width="200">
                        <template slot-scope="scope">
                            {{ scope.row.course ? scope.row.course.title : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="exam_num" label="考试人数" width="100"></el-table-column>
                    <el-table-column prop="question_number" label="题目数量" width="100"></el-table-column>
                    <el-table-column prop="total_score" label="试卷总分" width="100"></el-table-column>
                    <el-table-column prop="status_desc" label="状态" width="100"></el-table-column>
                    <el-table-column prop="sort" label="排序" width="60"></el-table-column>
                    <el-table-column prop="create_time" label="添加时间" width="150"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="130">
                        <template slot-scope="scope">
                            <el-button @click="handleDetail(scope.row)" type="text" size="small" v-auth="'/education/exam/detail'">详情</el-button>
                            <el-button @click="handleEdit(scope.row)" type="text" size="small" v-auth="'/education/exam/add'">编辑</el-button>
                            <el-button @click="handleDelete(scope.row)" type="text" size="small" v-auth="'/education/exam/del'">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        background
                        :current-page="query.page"
                        :page-size="query.list_rows"
                        layout="total, prev, pager, next, jumper"
                        :total="total"></el-pagination>
            </div>
        </div>
        <!--添加编辑-->
        <edit ref="edit" @fetch-data="refresh"></edit>
        <detail ref="detail" @fetch-data="refresh"></detail>
    </div>
</template>

<script>
    import { examList, examDel } from '@/api/education';
    import Edit from './edit';
    import Detail from './detail';

    export default {
        components: {
            /*编辑组件*/
            Edit,
            Detail,
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                total: 0,
                /*横向表单数据模型*/
                form: {
                    become: '0'
                },
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                userModel: {},
                query: {
                    exam_type: '',
                    create_time: '',
                    keyword: '',
                    page: 1,
                    list_rows: 10,
                },
                select_type_array: [],

            };
        },
        created() {
            /*获取列表*/
            this.getTableList();
        },
        methods: {
            /*获取列表*/
            getTableList() {
                this.loading = true
                examList(this.query).then((result)=>{
                    this.loading = false
                    this.select_type_array = result.data.select_type
                    this.tableData = result.data.list
                    this.total = result.data.count
                })
            },
            // 刷新
            refresh() {
                this.query = this.$options.data().query
                this.getTableList()
            },
            // 查询
            search() {
                this.query.page = 1
                this.getTableList()
            },
            // 详情
            handleDetail(row){
                this.$refs['detail'].showDialog(row)
            },
            // 添加
            handleAdd(){
                this.$refs['edit'].showDialog()
            },
            // 编辑
            handleEdit(row) {
                this.$refs['edit'].showDialog(row)
            },
            // 删除
            handleDelete(row) {
                if (row.exam_id) {
                    this.$confirm('确定要删除当前项吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        examDel({ids: row.exam_id}).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.getTableList()
                        })
                    }).catch(() => {

                    });
                } else {
                    // if (this.selection.length > 0) {
                    //     this.$confirm('确定要删除选中项吗?', '提示', {
                    //         confirmButtonText: '确定',
                    //         cancelButtonText: '取消',
                    //         type: 'warning'
                    //     }).then(() => {
                    //         agentDel({ids: this.selectIds}).then((result)=>{
                    //             this.$message({type: 'success', message: result.msg});
                    //             this.list()
                    //         })
                    //     }).catch(() => {
                    //
                    //     });
                    //
                    // } else {
                    //     this.$message({type: 'error', message: '未选中任何项'});
                    // }
                }
            },
            //选择第几页
            handleCurrentChange(val) {
                this.query.page = val;
                this.getTableList();
            },
            //每页多少条
            handleSizeChange(val) {
                this.query.list_rows = val;
                this.getTableList();
            },
            // 切换题目类型时
            questionTypeChange(val){
               this.query.exam_type = val
            },
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/education/exam/exam/index.vue